import { put, take, takeEvery, select, call } from "redux-saga/effects";
import { delay } from "redux-saga";
import { LoginConstants } from "../constants/login.constants";
import {
    loginSuccess,
    loginFailure,
    receivedApiToken,
    updateUserSettings
} from "../actions/login.actions";
import { auth } from "../api/auth";
import { replace, push } from "react-router-redux";
import { doGraphQLQuery } from "./graphql.saga";
import { getUserQuery } from "./query.helper";
import store from "store";

export function* logout(getFirebase) {
    yield takeEvery(LoginConstants.LOGOUT, doLogout, getFirebase);
}

const hasLoggedInKey = "hasLoggedIn";

function* doLogout(getFirebase) {
    try {
        yield getFirebase().logout();
    } catch (e) {
        console.log("something went wrong logging out", e);
    }
    store.set(hasLoggedInKey, false);
    yield put(push("/"));
}

export function* login(getFirebase) {
    yield takeEvery(LoginConstants.LOGIN, doLogin, getFirebase);
}

function* doLogin(getFirebase, action) {
    const credentials = action.payload;
    try {
        yield getFirebase().login(credentials);
        yield put(loginSuccess());
    } catch (e) {
        console.log("something went wrong logging in.", e);
        yield put(loginFailure({ error: e }));
    }
}

export function* receivedToken() {
    yield takeEvery(LoginConstants.RECEIVED_ID_TOKEN, doReceivedToken);
}

export function* checkLoginToken() {
    yield takeEvery(LoginConstants.CHECK_API_TOKEN, doCheckLoginToken);
}

function* fetchAndUpdateUserSettings() {
    const uid = yield select(({ userSettings: { user: { uid } } }) => {
        return uid;
    });

    const response = yield call(doGraphQLQuery, getUserQuery(uid));

    yield put(updateUserSettings(response));
}

export function* initiateLoginCheck() {
    while (true) {
        yield take(LoginConstants.INITIATE_LOGIN_CHECK);
        yield delay(5000);
        const {
            loggedIn,
            pathname
        } = yield select(
            ({
                userSettings: { loggedIn },
                router: { location: { pathname } }
            }) => {
                return { loggedIn, pathname };
            }
        );
        if (!loggedIn && pathname !== "/" && pathname !== "/login") {
            const redirectUrl = `/login?redirect=${encodeURIComponent(
                pathname
            )}`;
            yield put(push(redirectUrl));
        }
    }
}

export function* doCheckLoginToken() {
    const { token } = yield select(state => {
        return {
            token: state.userSettings.apiToken
        };
    });

    if (!token) {
        return;
    }

    try {
        yield call(fetchAndUpdateUserSettings);
    } catch (e) {
        // If something went wrong fetching the user, abort.
        console.log(e);
        return;
    }

    store.set(hasLoggedInKey, true);

    let languages = yield select(({ userSettings: { languages } }) => {
        return languages;
    });

    if (languages.count() === 0) {
        yield put(replace("/setup/step/1"));
    }
}

function* doReceivedToken(action) {
    const { idToken, skipReauth } = action.payload;
    if (skipReauth) {
        return;
    }
    try {
        const response = yield call(auth, idToken);
        yield put(receivedApiToken(response));
        yield call(doCheckLoginToken);
    } catch (e) {
        yield put(logout());
    }
}



// WEBPACK FOOTER //
// ./src/sagas/login.saga.js